/*
 * Module for the category header
 */

define([
  "backbone",
  "marionette",
  "messaging/messenger",
  "./modalViewContainerView",
  "modules/topicsSplit/topic/topicResponse/topicCategories/topicCategoriesAddModal/categoryAddModalModule",
], function (Backbone, Marionette, Messenger, ModalViewContainerView, CategoryAddModalModule) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "modalViewContainer";
      this.region = options.region;
      this._setUpVents();
    },

    show: function (categories) {
      this.tempCategoryKey = [];
      this.categories = categories;
      this.categoryOptions = Messenger.reqres.request("kb:categories");
      this.categoryIdToNameMap = new Map();
      this.categoryIdToDescriptionMap = new Map();
      this.categoryValueIdToDescriptionMap = new Map();
      this.categoryValueIdToNameMap = new Map();

      // map of category id to category value Ids that are part of category text search results
      this.catIdToValueIdsMap = new Map();

      // Create id to name maps
      this.categoryOptions.forEach(function (cat) {
        this.categoryIdToNameMap.set(cat.get("categoryId"), cat.get("categoryName"));
        this.categoryIdToDescriptionMap.set(cat.get("categoryId"), cat.get("description"));
        cat.getValues().forEach(function (catValue) {
          this.categoryValueIdToNameMap.set(catValue.get("categoryValueId"), catValue.get("value"));
          this.categoryValueIdToDescriptionMap.set(
            catValue.get("categoryValueId"),
            catValue.get("description"),
          );
        }, this);
      }, this);

      this.layout = new ModalViewContainerView.modalLayout({
        model: new Backbone.Model({
          categories: this.categoryOptions,
        }),
      });
      this.categoryContainer = this.addSubModule(
        new CategoryAddModalModule({ region: this.layout.categoryContainer }),
      );
      this.layout.on(
        "show",
        function () {
          this.categoryContainer.show(
            this.categories,
            this.categoryOptions,
            this.catIdToValueIdsMap,
          );
        },
        this,
      );

      //set default search mode
      let filteredCategories;
      this.layout.on(
        "click:category:search",
        function (args) {
          const searchText = args.searchText;
          // reset the map
          this.catIdToValueIdsMap.clear();
          filteredCategories = this._filterCategoriesBasedOnCategoryNameOrValue(
            this.categoryOptions,
            searchText,
          );
          this.categoryContainer.show(this.categories, filteredCategories, this.catIdToValueIdsMap);
        },
        this,
      );

      this.layout.on(
        "done",
        () => {
          this.tempCategoryKey.forEach((key) => {
            // key is categoryId-categoryValueId
            const keySplit = key.split("-");
            const categoryId = keySplit[0];
            const categoryValueId = keySplit[1];
            categories.addCategory(
              parseInt(categoryId),
              this.categoryIdToNameMap.get(parseInt(categoryId)),
              parseInt(categoryValueId),
              this.categoryValueIdToNameMap.get(parseInt(categoryValueId)),
              this.categoryIdToDescriptionMap.get(parseInt(categoryId)),
              this.categoryValueIdToDescriptionMap.get(parseInt(categoryValueId)),
            );
          });
          categories.saveCollection({
            success: () => {
              Messenger.saveAttempted(true);
              Messenger.vent.trigger("topic:category:list:refresh", categories);
              Messenger.vent.trigger("close:modal");
            },
          });
        },
        this,
      );

      this.layout.on(
        "cancel",
        function () {
          Messenger.vent.trigger("close:modal");
        },
        this,
      );

      this.showRegion(this.layout);
    },
    escapeRegex(string) {
      // eslint-disable-next-line no-useless-escape
      return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    },
    _filterCategoriesBasedOnCategoryNameOrValue: function (categoriesOpts, searchText) {
      searchText = searchText.trim();
      if (searchText.length === 0) {
        return categoriesOpts;
      }
      const searchRegex = new RegExp(this.escapeRegex(searchText), "i");
      const _this = this;
      return categoriesOpts.filter(function (item) {
        //check if the category name matches
        const nameMatched = item.get("categoryName").match(searchRegex);
        const catId = parseInt(item.get("categoryId"));
        const filteredCatValues = item.getValues().filter(function (catVal) {
          return catVal.get("value").match(searchRegex);
        });
        if (filteredCatValues.length > 0) {
          // only display these category values
          filteredCatValues.forEach(function (catValue) {
            const catValId = parseInt(catValue.get("categoryValueId"));
            if (_this.catIdToValueIdsMap.has(catId)) {
              _this.catIdToValueIdsMap.get(catId).push(catValId);
            } else {
              _this.catIdToValueIdsMap.set(catId, [catValId]);
            }
          });
        }
        return nameMatched || filteredCatValues.length > 0;
      });
    },
    _setUpVents: function () {
      //event when a node from the conversation diagram is selected
      Messenger.vent.on(
        "topic:categories:multi-select:add",
        function (categoryKey) {
          this.tempCategoryKey.push(categoryKey);
        },
        this,
      );

      Messenger.vent.on(
        "topic:categories:multi-select:remove",
        function (categoryKey) {
          this.tempCategoryKey = this.tempCategoryKey.filter(function (element) {
            return element !== categoryKey;
          });
        },
        this,
      );

      Messenger.vent.on(
        "change:categories:search:mode",
        function (modeSelected) {
          this.categoryOptions.mode = modeSelected;
        },
        this,
      );

      Messenger.reqres.setHandler(
        "get:response:conversationNode",
        function () {
          return this.conversation;
        },
        this,
      );
    },
  });
});
